import React from "react";
import {
  StyledBannerContainer,
  StyledImageContainer,
  StyledBannerImage,
  StyledShippingImg,
} from "./style";
import BannerImage from "../../assets/images/rectangle.png";
import WelcomeBannerFont from "./WelcomeBannerFont";
import shippingBanner from "../../assets/images/connecting-NRI.png";

const WelcomeBanner = () => {
  return (
    <StyledBannerContainer>
      <WelcomeBannerFont />
      <StyledImageContainer>
        <StyledBannerImage
          src={BannerImage}
          alt="Connecting NRIs"
          loading="lazy"
        />
        <StyledShippingImg
          src={shippingBanner}
          alt="shippingBanner"
          loading="lazy"
        />
      </StyledImageContainer>
    </StyledBannerContainer>
  );
};

export default WelcomeBanner;
